<template>
    <div class="tag">{{ text }}</div>
</template>

<script>
    export default {
        name: 'tag',
        props: {
            text: String,
        }
    }
</script>

<style scoped lang="scss">
.tag {
    @apply rounded-md italic;
    max-width: 150px;
    @media(max-width: 639px) {
        @apply py-2 px-5 text-xs;
    }
    @media(min-width: 640px){
        @apply text-sm py-2 px-5;
    }
}
</style>
